import { defaultSchema } from "@atlaskit/adf-schema/schema-default";
import { EmailSerializer } from "@atlaskit/email-renderer";
import dompurify from "dompurify";
import { DATE_FORMATS } from "#utils/constants";
import { formatFullDateAndTimeWithLocalTimezone } from "#utils/datetime";

export const formatCommentDate = (dateString: string): string => {
  return formatFullDateAndTimeWithLocalTimezone(dateString, DATE_FORMATS["MM/DD/YYYY"].long);
};

export const isAutomatedComment = (authorDisplayName: string): boolean => {
  return authorDisplayName.toLowerCase().includes("automation");
};

const decodeHtmlEntities = (html: string): string => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = html;
  return textarea.value;
};

export const convertAdfToHtml = (adfDocument: unknown): string => {
  try {
    if (!adfDocument || typeof adfDocument !== "object") {
      return "";
    }

    const serializer = EmailSerializer.fromSchema(defaultSchema as never);
    const node = defaultSchema.nodeFromJSON(adfDocument);
    const rawHtml = serializer.serializeFragment(node.content);
    const decodedHtml = decodeHtmlEntities(rawHtml);

    return dompurify.sanitize(decodedHtml);
  } catch {
    return "";
  }
};
